import { getApiURL } from '../utils/env';
import { buildUrlParams, getResponseBody } from '../utils/requestsHelpers';

const defaultConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

function useRequests() {
  const apiURL = getApiURL();
  async function get(endpoint, params = {}) {
    let url = `${apiURL}${endpoint}`;
    if (endpoint.includes('http')) {
      url = endpoint;
    }
    const urlParams = buildUrlParams(params);
    const response = await fetch(`${url}${urlParams}`, defaultConfig);
    const { status } = response;
    const data = await getResponseBody(response);

    return { status, data };
  }

  async function post(endpoint, bodyObject = {}, customHeaders = {}) {
    let url = `${apiURL}${endpoint}`;
    if (endpoint.includes('http')) {
      url = endpoint;
    }
    const body = bodyObject instanceof FormData ? bodyObject : JSON.stringify(bodyObject);
    const { credentials, headers: defaultHeaders } = defaultConfig;
    const headers = bodyObject instanceof FormData ? {} : { ...customHeaders, ...defaultHeaders };
    const response = await fetch(url, {
      credentials,
      headers,
      method: 'POST',
      body,
    });
    const { status } = response;
    const data = await getResponseBody(response);

    return { status, data };
  }

  return { get, post };
}

export default useRequests;
